// TODO: These things should really be a regex or something
const replaceAllAccents = text => {
  return text
    .replaceAll("á", "a")
    .replaceAll("é", "e")
    .replaceAll("í", "i")
    .replaceAll("ó", "o")
    .replaceAll("ú", "u")
    .replaceAll("à", "a")
    .replaceAll("â", "a")
    .replaceAll("è", "e")
    .replaceAll("ê", "e")
    .replaceAll("ì", "i")
    .replaceAll("î", "i")
    .replaceAll("ò", "o")
    .replaceAll("ô", "o")
    .replaceAll("ù", "u")
    .replaceAll("û", "u")
    .replaceAll("ç", "c")
    .replaceAll("ã", "a")
    .replaceAll("õ", "o")
    .replaceAll("ñ", "n")
}

const slugify = text => {
  const result = text
    .toLowerCase()
    .replaceAll(" ", "-")
    .replace(/[.,\/#!$%?¿\^&\*;:{}=’\_'`~()]/g, "")

  return replaceAllAccents(result)
}

module.exports = { slugify }
